export default function DashaTableHeading() {
  return (
    <tr className="bg-indigo-50 border-b border-indigo-200">
      <th className="py-3 px-4 text-left text-indigo-700 font-semibold tracking-wide">
        Zodiac Name
      </th>
      <th className="py-3 px-4 text-left text-indigo-700 font-semibold tracking-wide">
        Zodiac Sign
      </th>
      <th className="py-3 px-4 text-left text-indigo-700 font-semibold tracking-wide">
        Start Time
      </th>
      <th className="py-3 px-4 text-left text-indigo-700 font-semibold tracking-wide">
        End Time
      </th>
    </tr>
  );
}
